import type { RoutineTimelineState } from './types/RoutineTimeline.types';
import type { IState } from 'app/cross-cutting-concerns/state-management/interfaces/IState';
import type { Optional } from 'lib/types/Optional';

export const selectRoutineTimeline = (state: IState): RoutineTimelineState =>
  state.modules['machine-inventory']['routine-timeline'];

/** The name of the routine's last route, once the routine is loaded. */
export const selectRoutineLastRouteName = (state: IState): Optional<string> => {
  const { routine, routes } = selectRoutineTimeline(state);
  const lastRouteId = routine?.routeIds[routine.routeIds.length - 1];

  return lastRouteId == null ? null : routes[lastRouteId]?.name;
};

export const selectRoutineTimelineTaskId = (state: IState): Optional<string> => selectRoutineTimeline(state).taskId;

/** The route the run with this task id stopped on, when that was seen; null for any other run. */
export const selectRoutineStoppedStep = (state: IState, taskId: Optional<string>): Optional<number> => {
  const { taskId: timelineTaskId, stoppedStep } = selectRoutineTimeline(state);

  return taskId && timelineTaskId === taskId ? stoppedStep : null;
};
